import { RootState } from "../reducers";

export const getAllLayerTempStyles = ({ layerTempStyle }: RootState) => layerTempStyle;

export const getLayerTempStyle = ({ layerTempStyle }: RootState, layerName: string) =>
  layerTempStyle && layerTempStyle[layerName];
